export const EXCEL_MIME_TYPES =  [
    'application/vnd.ms-excel',
    'application/msexcel',
    'application/x-msexcel',
    'application/x-ms-excel',
    'application/x-excel',
    'application/x-dos_ms_excel',
    'application/xls',
    'application/x-xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
].join(',');

export const JSON_MIME_TYPE = ['application/json', 'application/geo+json'].join(','); 



/** WEBPACK FOOTER **
 ** ./app/utils/extensions.ts
 **/